import { Component } from '@angular/core';
import { OrderService, VoucherService } from '@app/_services';
import { Pagination } from '@app/_interfaces/pagination.interface';
import { ceil } from 'lodash';
import { debounceTime, switchMap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CurrencyFormatPipe } from '../../../../shared/pipes/currency-format.pipe';
import { NgIf, NgFor, DatePipe } from '@angular/common';

@Component({
    selector: 'app-page-vouchers',
    templateUrl: './page-vouchers.component.html',
    styleUrls: ['./page-vouchers.component.scss'],
    standalone: true,
    imports: [NgIf, NgFor, DatePipe, CurrencyFormatPipe, TranslateModule]
})
export class PageVouchersComponent {

    constructor(private voucherService: VoucherService,
        private route: ActivatedRoute,
        private router: Router) { }

    vouchers;
    // paginationOrderCount;
    // pagination: Pagination = {
    //     page: 1,
    //     limit: 10
    // }
    paginationSubject$: Subject<any> = new Subject();
    ngOnInit() {
        this.voucherService.getVouchers({}).subscribe((response :any) => {
            this.vouchers = response.data;
            // this.paginationOrderCount = ceil(response.orderCount / 10)
        });

        this.paginationSubject$.pipe(
            debounceTime(1000),
            switchMap(() => {
                // this.updateUrl();
                return this.voucherService.getVouchers({});
            })
        ).subscribe((response:any) => {
            this.vouchers = response.data;
        })
    }

}
